(() => {
  const button = document.querySelector('.sc-floating-configurator');
  if (!button) return;
  const placeholder = document.createElement('span');
  placeholder.hidden = true;
  button.before(placeholder);

  let resizeFrame;

  const placeButton = () => {
    const header = document.querySelector('.section-header, .sc-local-header');
    const actions = header?.querySelector('.header__icons, .nav-tools');
    const customMount = actions?.querySelector('.sc-header-cta');
    button.classList.remove('sc-drawer-rack-cta');
    if (innerWidth >= 990 && actions && customMount) {
      actions.insertBefore(button, customMount);
      button.hidden = false;
      return;
    }
    const drawer = header?.querySelector('.menu-drawer__navigation, .mobile-menu > div');
    let drawerCustom = drawer?.querySelector('.sc-drawer-cta');
    if (drawer && !drawerCustom && customMount && header.matches('.sc-local-header')) {
      drawerCustom = customMount.cloneNode(true);
      drawerCustom.classList.add('sc-drawer-cta');
      drawer.append(drawerCustom);
    }
    if (drawer && drawerCustom) {
      drawer.insertBefore(button, drawerCustom);
      button.classList.add('sc-drawer-rack-cta');
      button.hidden = false;
      return;
    }
    placeholder.after(button);
    button.hidden = true;
  };

  const scheduleUpdate = () => {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(placeButton);
  };

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('pageshow', scheduleUpdate);
  document.addEventListener('shopify:section:load', placeButton);
  document.addEventListener('shopify:section:unload', () => {
    placeholder.after(button);
    button.hidden = true;
    scheduleUpdate();
  });
  placeButton();
})();
